document.addEventListener("DOMContentLoaded", function(){
    console.log("loaded")
    console.log(window.location.hash)
});

// When topic is selected, move the page to that topic
function scrollToHash(hashName) {
  location.hash = '#' + hashName;
};
function onSelectTopic(e){
  e = e || window.event;
  const topic = e.target.value;
  scrollToHash(topic);
};

// Back To Top btn
$('#scroll-to-top').click(function() {
  window.scrollTo(0,0);
  return false;
});

// $(document).ready(function(){
//   console.log("loaded")
//   function scrollToHash(hashName) {
//    location.hash = '#' + hashName;
//  };
  
//   $('#select-topic').on('change', function(e){


//       $('html, body').animate({
//         scrollTop: $(hash).offset().top
//       }, 800)

//   });
//   })
  
  
// })
